// retiremnt
export const LEAD_UPDATE_GOALTYPE = 'LEAD_UPDATE_GOALTYPE';
export const LEAD_RETIREMENT_AGE = 'LEAD_RETIREMENT_AGE';
export const LEAD_MONTHLY_INCOME = 'LEAD_MONTHLY_INCOME';
export const LEAD_RETIREMENT_INCOME = 'LEAD_RETIREMENT_INCOME';
export const LEAD_ANNUAL_SAVING = 'LEAD_ANNUAL_SAVING';
export const LEAD_SKIP_GOAL_INFO = 'LEAD_SKIP_GOAL_INFO';
export const LEAD_INVESTER_TARGET = 'LEAD_INVESTER_TARGET';
export const LEAD_NAV_STATE = 'LEAD_NAV_STATE';
export const LEAD_GOAL_SCREEN = 'LEAD_GOAL_SCREEN';
export const UPDATE_GOAL_DATA = 'UPDATE_GOAL_DATA';
export const RESET_GOAL_STATE = 'RESET_GOAL_STATE';

// new constants for Gaol state
export const GOAL_goalId = 'GOAL_goalId';
export const GOAL_Amount = 'GOAL_Amount';
export const GOAL_GoalType = 'GOAL_GoalType';
export const GOAL_TargetAmount = 'GOAL_TargetAmount';
export const GOAL_BirthYear = 'GOAL_BirthYear';
